function updateSizes(card, swatch) {
  const container = card.querySelector('.hover-sizes');
  if (!container) return;

  const sizes = JSON.parse(swatch.dataset.sizes || '[]');

  container.innerHTML = '';

  sizes.forEach(size => {
    const span = document.createElement('span');

    span.className = 'size' + (size.available ? '' : ' sold-out');
    span.textContent = size.title;

    if (!size.available) {
      container.appendChild(span);
      return;
    }

    const variantId = size.id;

    span.dataset.variantId = variantId;

    span.addEventListener('click', async () => {
      container.querySelectorAll('.size').forEach(s => s.classList.remove('active'));
      span.classList.add('active');

      if (!variantId) {
        console.warn('No variantId found');
        return;
      }

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });

      if (!res.ok) {
        console.error(await res.text());
        return;
      }

      document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
      document.dispatchEvent(new CustomEvent('theme:cart:open'));

      span.classList.add('added');
    });

    container.appendChild(span);
  });
}

function initColorHover() {
  document.querySelectorAll('.hover-swatch:not(.hasevent)').forEach((swatch) => {
    const card = swatch.closest('[data-product-block]');
    if (!card) return;

    const mainImg = card.querySelector('[data-product-image] img');
    const hoverImg = card.querySelector('[data-product-image-hover] img');

    swatch.addEventListener('click', (e) => {
      e.preventDefault();

      card.querySelectorAll('.hover-swatch').forEach(s => s.classList.remove('active'));
      swatch.classList.add('active');

      if (mainImg && swatch.dataset.img) {
        mainImg.src = swatch.dataset.img;
        mainImg.srcset = swatch.dataset.img;
      }

      if (hoverImg && swatch.dataset.imgHover) {
        hoverImg.src = swatch.dataset.imgHover;
        hoverImg.srcset = swatch.dataset.imgHover;
      }

      card.querySelector('.product__media__holder')
        ?.dispatchEvent(new Event('mouseleave'));

      updateSizes(card, swatch);
    });
    swatch.classList.add('hasevent');
  });

  document.querySelectorAll('[data-product-block]').forEach(card => {
    const active = card.querySelector('.hover-swatch.active');
    if (active) updateSizes(card, active);
  });

  document.querySelectorAll('.imagen-color-item:not(.hoverInit)').forEach(item => {
    item.addEventListener('mouseenter', () => {
      handlePDPColorHover(item);
    });

    item.classList.add('hoverInit');
  });

  document.querySelectorAll('.imagen-colores:not(.hoverContainerInit)').forEach(container => {
    const items = container.querySelectorAll('.imagen-color-item');
    const originalActive = container.querySelector('.imagen-color-item.active');

    if (originalActive) {
      container.dataset.originalIndex = [...items].indexOf(originalActive);
    }

    container.addEventListener('mouseleave', () => {
      items.forEach(item => item.classList.remove('active'));

      const index = container.dataset.originalIndex;
      const originalItem = items[index];

      if (originalItem) {
        originalItem.classList.add('active');

        const colorName = originalItem.dataset.colorName;
        const span = document.getElementById('color-name');

        if (span && colorName) {
          span.textContent = `Color: ${colorName}`;
        }
      }
    });

    container.classList.add('hoverContainerInit');
  });
}

function initTabsColorHover() {
  let lastTab = null;

  document.addEventListener('click', function (e) {
    const tab = e.target.closest('.tabs__link');
    if (!tab) return;

    // Evita ejecutar si es la misma pestaña
    if (tab === lastTab) return;
    lastTab = tab;

    // Espera a que el contenido se renderice
    setTimeout(() => {
      initColorHover();
    }, 100);
  });
}

function switchGallery(card, productId) {
  const galleries = card.querySelectorAll('.product-gallery-group');

  galleries.forEach((gallery) => {
    gallery.classList.remove('active');
  });

  const nextGallery = card.querySelector(
    `.product-gallery-group[data-product-gallery="${productId}"]`
  );

  if (nextGallery) {
    nextGallery.classList.add('active');
  }

}

function findProductSelect(card) {
  const scope = card.closest('product-info') || card.closest('[data-quick-view-inner]') || card.parentElement;
  const el = scope ? scope.querySelector('[data-product-select]') : null;
  return el;
}

function findScope(card) {
  return card.closest('product-info') || card.closest('[data-quick-view-inner]') || card.parentElement;
}

function updatePrice(card, variant) {
  if (!variant) return;
  const scope = findScope(card);
  if (!scope) {
    console.warn('[siblings] updatePrice — no scope');
    return;
  }

  const isSale = variant.compare_at_price > variant.price;

  scope.querySelectorAll('[data-product-price]').forEach(el => {
    el.textContent = variant.price_formatted || '';
    el.classList.toggle('product__price--sale', isSale);
    el.classList.toggle('product__price--regular', !isSale);
  });

  scope.querySelectorAll('[data-compare-price]').forEach(el => {
    if (isSale) {
      el.textContent = variant.compare_at_price_formatted || '';
      el.classList.remove('hidden');
    } else {
      el.classList.add('hidden');
    }
  });
}

function updateStock(card, variant) {

  if (!variant) return;

  const scope = findScope(card);

  if (!scope) return;

  const inventoryWrapper = scope.querySelector(
    '[data-remaining-wrapper]'
  );

  if (!inventoryWrapper) return;

  const countEl = inventoryWrapper.querySelector(
    '[data-remaining-count]'
  );

  const stock = variant.inventory_quantity ?? 0;

  const max = parseInt(
    inventoryWrapper.dataset.remainingMax || 5
  );

  inventoryWrapper.classList.remove(
    'count-is-low',
    'count-is-in',
    'count-is-out'
  );

  const managesInventory =
    variant.inventory_management === 'shopify';

  const denyPolicy =
    variant.inventory_policy === 'deny';

  if (managesInventory && denyPolicy) {

    if (stock > 0 && stock <= max) {

      inventoryWrapper.classList.add('count-is-low');

    } else if (stock > 0) {

      inventoryWrapper.classList.add('count-is-in');

    } else {

      inventoryWrapper.classList.add('count-is-out');
    }

  } else {

    inventoryWrapper.classList.add('count-is-in');
  }

  if (countEl) {
    countEl.textContent = stock;
  }
}

document.addEventListener('click', (e) => {
  const colorItem = e.target.closest('.imagen-color-item');
  if (!colorItem) return;

  const card = colorItem.closest('[data-product-block]');
  if (card) {
    const productId = colorItem.dataset.productId;

    card.querySelectorAll('.imagen-color-item').forEach(item => {
      item.classList.remove('active');
    });

    colorItem.classList.add('active');

    switchGallery(card, productId);
    renderSizes(card, colorItem);

    return;
  }

});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-block]').forEach(card => {
    const activeColor = card.querySelector('.imagen-color-item.active');
    if (!activeColor) return;
    renderSizes(card, activeColor);
    renderInventory(card, activeColor);
  });
});

function renderSizes(card, colorItem) {
  const container = card.querySelector('.hover-sizes');
  if (!container) {
    console.warn('[siblings] renderSizes — no .hover-sizes en card:', card);
    return;
  }

  const variants = JSON.parse(colorItem.dataset.variants || '[]');
  const firstAvailable = variants.find(v => v.available);

  container.innerHTML = '';

  variants.forEach(variant => {
    const wrapper = document.createElement('span');
    wrapper.className = `radio__button ${variant.available ? '' : 'sold-out'}`;

    const inputId = `quick-size-${variant.id}`;
    const input = document.createElement('input');
    input.type = 'radio';
    input.className = 'radio__input';
    input.name = 'options[Size]';
    input.id = inputId;
    input.value = variant.title;
    input.dataset.variantId = variant.id;
    if (!variant.available) input.disabled = true;
    if (firstAvailable && firstAvailable.id === variant.id) input.checked = true;

    const label = document.createElement('label');
    label.className = 'radio__label';
    label.setAttribute('for', inputId);
    label.innerHTML = `<span class="option-title">${variant.title}</span>`;

    wrapper.appendChild(input);
    wrapper.appendChild(label);
    container.appendChild(wrapper);
  });

  if (firstAvailable) {
    const productSelect = findProductSelect(card);
    if (productSelect) {
      productSelect.value = firstAvailable.id;
    }
    updatePrice(card, firstAvailable);
    updateStock(card, firstAvailable);
  }
}

document.addEventListener('change', (e) => {
  const sizesContainer = e.target.closest('.hover-sizes');
  if (!sizesContainer) return;

  const card = sizesContainer.closest('[data-product-block]');
  if (!card) {
    console.warn('[siblings] change .hover-sizes — no [data-product-block]');
    return;
  }

  const activeColor = card.querySelector('.imagen-color-item.active');
  const originalItem = card.querySelector('.imagen-color-item');

  if (!activeColor) return;
  if (activeColor === originalItem) {
    return;
  }

  e.stopImmediatePropagation();

  const variantId = e.target.dataset.variantId;

  if (variantId) {
    const productSelect = findProductSelect(card);
    if (productSelect) {
      productSelect.value = variantId;
    }

    const activeColor = card.querySelector('.imagen-color-item.active');
    if (activeColor) {
      const variants = JSON.parse(activeColor.dataset.variants || '[]');
      const selectedVariant = variants.find(v => String(v.id) === String(variantId));
      if (selectedVariant) {
        updatePrice(card, selectedVariant);
        updateStock(card, selectedVariant);
      }
    }
  }
}, true);

function handlePDPColorHover(colorItem) {
  const container = colorItem.closest('.imagen-colores');
  if (!container) return;

  container.querySelectorAll('.imagen-color-item').forEach(item => {
    item.classList.remove('active');
  });

  colorItem.classList.add('active');
  const colorName = colorItem.dataset.colorName;
  const span = document.getElementById('color-name');

  if (span && colorName) {
    span.textContent = `Color: ${colorName}`;
  }

  console.log('PDP color cambiado:', colorName);
  console.log(document.querySelectorAll('#color-name'));
  console.log(colorItem.dataset.colorName);
}


document.addEventListener('DOMContentLoaded', () => {
  initColorHover();
  initTabsColorHover();
});

document.addEventListener('theme:slider:resize', initColorHover);